import cn from 'classnames';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, lucideIcons } from '@round/creatorbase-ui';
import { creatorbase } from '@round/api';
import useClientSelect from 'Modules/Plans/Clients/hooks/useClientSelect';
import { useCreatorPoolsList } from './hooks/useCreatorPoolsList';
import { CreatorPoolsTable } from './components/CreatorPoolsTable/CreatorPoolsTable';
import { CreatePoolModal } from '../components/CreatePoolModal/CreatePoolModal';
import { DeletePoolModal } from './components/DeletePoolModal/DeletePoolModal';
import styles from './CreatorPoolsList.module.css';

const { Plus } = lucideIcons;

export const CreatorPoolsList = () => {
    const navigate = useNavigate();
    const { selectedClientId } = useClientSelect();
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [poolToDelete, setPoolToDelete] = useState<creatorbase.Pool | null>(null);
    const { rows, isLoading, hasError, getIsUserLoading, hasNextPage, isFetchingNextPage, fetchNextPage } =
        useCreatorPoolsList();

    return (
        <div className={cn(styles.container, 'twp')}>
            <header className={cn(styles.section, styles.header)}>
                <h1 className={styles.title}>Creator Pools</h1>
                <Button size="xs" disabled={typeof selectedClientId !== 'number'} onClick={() => setIsCreateOpen(true)}>
                    <Plus /> Pool
                </Button>
            </header>
            <section className={cn(styles.section, styles.tableSection)}>
                <CreatorPoolsTable
                    rows={rows}
                    meta={{ isLoading, hasError, getIsUserLoading }}
                    fetchNextPage={() => {
                        if (hasNextPage && !isFetchingNextPage) {
                            void fetchNextPage();
                        }
                    }}
                    onDeletePool={setPoolToDelete}
                />
            </section>

            <CreatePoolModal
                isOpen={isCreateOpen}
                onClose={() => setIsCreateOpen(false)}
                onCreated={(pool) => navigate(`${pool.id}/`)}
            />

            <DeletePoolModal isOpen={poolToDelete !== null} pool={poolToDelete} onClose={() => setPoolToDelete(null)} />
        </div>
    );
};
